// GENERATED by scripts/icons/generate_icons.py. Do not edit by hand.
import { createIcon } from "./createIcon";

export const ChevronRightIcon = /*#__PURE__*/ createIcon("ChevronRight", "M7.65 4.15c.2-.2.5-.2.7 0l5.49 5.46c.21.22.21.57 0 .78l-5.49 5.47a.5.5 0 0 1-.7-.71L12.8 10 7.65 4.85a.5.5 0 0 1 0-.7");
